<div class="label-container">


  @if (!loading) {
    @if (faIcon) {
      <fa-icon
        [icon]="locked ? faLock : faIcon"
        class="mr-2"
        [style.font-size]="faSize">
      </fa-icon>
    }
    <span [innerHtml]="label"></span>
  } @else {
    <div class="sk-fading-circle">
      <div class="sk-circle1 sk-circle"></div>
      <div class="sk-circle2 sk-circle"></div>
      <div class="sk-circle3 sk-circle"></div>
      <div class="sk-circle4 sk-circle"></div>
      <div class="sk-circle5 sk-circle"></div>
      <div class="sk-circle6 sk-circle"></div>
      <div class="sk-circle7 sk-circle"></div>
      <div class="sk-circle8 sk-circle"></div>
      <div class="sk-circle9 sk-circle"></div>
      <div class="sk-circle10 sk-circle"></div>
      <div class="sk-circle11 sk-circle"></div>
      <div class="sk-circle12 sk-circle"></div>
    </div>
  }
</div>


<span class="disabled-area" (click)="disabledAreaClick($event)" *ngIf="disabled"></span>
